import type { FeedEntryType } from '../../types/FeedEntryType.type';

/**
 * Builds the variable set every getUserFeed call site needs, preserving
 * the active feedType and topic filters. Lifted out of recommendationFeed
 * so it's directly unit-testable — the prior bug (loadMorePosts and
 * refreshFeed silently dropping feedType / topic, replacing a Following
 * or topic-filtered feed with the default recommendation feed on the
 * first reconnect or page-2 load) was exactly the kind of regression
 * that slips through unless the variable shape is locked in by tests.
 */
export interface BuildFeedVariablesParams {
  userId: string | undefined;
  cursor: string | null;
  limit: number;
  feedType?: FeedEntryType | null;
  topic?: string | null;
}

export interface FeedQueryVariables {
  userId: string | undefined;
  cursor: string | null;
  limit: number;
  feedType?: FeedEntryType;
  topic?: string;
}

export function buildFeedVariables(
  params: BuildFeedVariablesParams,
): FeedQueryVariables {
  const { userId, cursor, limit, feedType, topic } = params;
  return {
    userId,
    cursor,
    limit,
    ...(feedType ? { feedType } : {}),
    ...(topic ? { topic } : {}),
  };
}
